// Copyright © 2025 The Things Industries B.V.

import React from 'react'
import { useParams } from 'react-router-dom'
import { defineMessages } from 'react-intl'

import STORAGE_INTEGRATION from '@console/constants/storage-integration'

import { useBreadcrumbs } from '@ttn-lw/components/breadcrumbs/context'
import Breadcrumb from '@ttn-lw/components/breadcrumbs/breadcrumb'
import PageTitle from '@ttn-lw/components/page-title'
import Notification from '@ttn-lw/components/notification'

import RequireRequest from '@ttn-lw/lib/components/require-request'
import Message from '@ttn-lw/lib/components/message'

import ApplicationMessageStorageContainer from '@console/containers/application-message-storage/index.tti'

import Require from '@console/lib/components/require'

import sharedMessages from '@ttn-lw/lib/shared-messages'

import { mayViewOrEditApplicationPackages } from '@console/lib/feature-checks'

import { getAppPkgDefaultAssoc } from '@console/store/actions/application-packages'

const m = defineMessages({
  messageStorageInfo: `Message storage allows storing received upstream messages in a persistent database, and retrieving them at a later time.`,
  warningNotification: 'This page is experimental and subject to change',
})

const ApplicationMessageStorage = () => {
  const { appId } = useParams()

  useBreadcrumbs(
    'apps.single.message-storage',
    <Breadcrumb
      path={`/applications/${appId}/message-storage`}
      content={sharedMessages.messageStorage}
    />,
  )

  return (
    <Require
      featureCheck={mayViewOrEditApplicationPackages}
      otherwise={{ redirect: `/applications/${appId}` }}
    >
      <RequireRequest
        requestAction={getAppPkgDefaultAssoc(appId, STORAGE_INTEGRATION.DEFAULT_PORT, ['data'])}
      >
        <div className="container container--xl grid">
          <div className="item-12">
            <Notification small warning content={m.warningNotification} className="mb-0" />
          </div>
          <PageTitle title={sharedMessages.messageStorage} className="mb-0">
            <Message content={m.messageStorageInfo} className="mt-0" />
          </PageTitle>
          <div className="item-12">
            <ApplicationMessageStorageContainer appId={appId} />
          </div>
        </div>
      </RequireRequest>
    </Require>
  )
}

export default ApplicationMessageStorage
